import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from "@angular/core";

@Directive()
export abstract class BaseCustomControl {

    abstract validate():boolean;
    protected onValueBound():void {
    }

    @Input() helpText:string = "";
    @Input() label:string = "";
    @Input() style:string = "";
    @Input() hint:string = "";

    // optional
    @Input() readonly:boolean = false;
    @Input() required:boolean = false;
    @Input() validateOn:string = "";  // consider changing to change (as keys are type) | blur (loses focus) | request (when called by parent)
    @Input() groupName = "";
    @Input() disabled:boolean = false;
    @Input() defaultValue: string|undefined = "N/A";
  
    @Output() onChanged:EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('inputControl') inputControl:ElementRef<HTMLInputElement>|undefined;


    myId:string;

    actualValue:any | undefined;    // this is what gets externally databound to "this"
    isValid:boolean = true;
    boundValue:any | undefined;     // this is what appears in the control
    validationMsg:string = "invalid";
    control_width_pct = "inherit";
    control_width_px = "inherit";
    illegalCharsRegEx:RegExp|undefined;
    illegalStringRegEx:RegExp|undefined;
    helpVisible:boolean = false;

    ngModelOptions = {};

    // Some Angular magic to tie our bound value to the ngModel:
    onChange:any = () => {};
    onTouch:any = () => {};
    // Suggested change:
    // CVA hooks:
    //   onChange: (val: any) => void = () => {};
    //   onTouch: () => void = () => {};


    constructor(private changeDetectorRef: ChangeDetectorRef) {
        this.myId = "cc" + Math.random().toString().replace("0.", "");
        //this.illegalCharsRegEx = new RegExp(/g/);
    }


    ngOnInit() {
        if (this.validateOn == "blur") {
            this.ngModelOptions = {updateOn:'blur'};
        }
    }

    writeValue(value: string | Date | null | undefined): void {

        if (value instanceof Date) {
            let s = this.toDateInputStringLocal(value);
            this.actualValue = s;
            this.boundValue = s;
        }
        else {
            this.actualValue = value;
            this.boundValue = value;
        }

        this.onValueBound();

        // Ensure view updates even with OnPush
        this.changeDetectorRef.markForCheck();   
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    protected toDateInputStringLocal(d: Date): string {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      }


    // End Angular magic


/* TODO (m4): This listens to clicks off of the popup help dialog but causes serious
performance issues. Figure out a better way to do this, because having this on 
numerous controls on a page is creating some page update latency issues. 
For now, I've switched to mouseover/mouseout, but this isn't touch-compatible.
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
        if (this.helpSettings.indexOf(this.myId) >= 0) {
            this.helpVisible = false;
            this.helpSettings.pop();
        }
    }
*/
    get labelValue(): string {
        return this.label;
    }

    get id():string {
        return this.myId;
    }

    public getLabel(): string {
        return this.label;
    }

    public getValidationMessage(): string {
        return this.validationMsg;
    }

    protected _handle_validateFailed() {
        this._showValidationMessage();
    }

    protected _handle_validatePassed() {
        this._clearValidationMessage();
    }

    public showHelp(event:Event) {
        this.helpVisible = true;
        event.stopPropagation()
    }
    public hideHelp(event:Event) {
        this.helpVisible = false;
        event.stopPropagation()
    }


    protected _clearValidationMessage() {
        if (this.inputControl) {
            this.inputControl.nativeElement.classList.remove('tb-valid', 'tb-invalid');
            this.inputControl.nativeElement.classList.add('tb-valid');
        }
    }

    protected _showValidationMessage() {
        if (this.inputControl) {
            this.inputControl.nativeElement.classList.remove('tb-valid', 'tb-invalid');
            this.inputControl.nativeElement.classList.add('tb-invalid');
        }
    }

    protected handle_onBlur(e:FocusEvent) {
        this.validate();
        this.onChanged.emit(this.boundValue);    
    }
}